import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const RetailerCardStyles = styled.div`
  background-color: #fff;
  border: solid 1px ${Colors.primary.black.tint};
  border-radius: 4px;
  padding: 20px;

  a.store-name-link:link,
  a.store-name-link:visited,
  a.store-name-link:hover,
  a.store-name-link:active {
    text-decoration: none;
  }

  .store-info {
    svg {
      margin: 0 5px 0 0;
      padding-top: 2px;
    }
  }
  .store-info-phone.desktop {
    display: none;
  }
  .store-address {
    display: flex;
  }
  .view-homes-link {
    color: ${Colors.primary.claytonBlue.standard};
    font-weight: 600;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    text-decoration: none;
    cursor: pointer;
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .store-info-phone.desktop {
      display: block;
    }
    .store-info-phone.mobile {
      display: none;
    }
  }
`;
